/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "@/components/ui/button";
import { DialogFooter } from "@/components/ui/dialog";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { useReactForm } from "../react-hook/use-react-form";
import { IconRender } from "@/components/shared/Icon-render";
import { ArrayInput, MultiSelectWithSearch } from "@/components/form-input";
import { RequiredInput } from "@/components/shared/required-input";

type UserFormType = {
  formData: any;
  onOpenChange: (prop: any) => void;
  onFormSubmit: (prop: boolean) => Promise<void>;
  open: boolean;
  retailerList: any;
};
export const ReactForm = ({
  formData,
  onOpenChange,
  onFormSubmit,
  open,
  retailerList,
}: UserFormType) => {
  const { form, onSubmit } = useReactForm({
    formData,
    onOpenChange,
    onFormSubmit,
    open,
  });

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="grid grid-cols-2 gap-x-6 gap-y-5 px-6">
          <FormField
            control={form.control}
            name="retailer_id"
            render={({ field }) => (
              <FormItem className="">
                <FormLabel>
                  Retailer name
                  <RequiredInput />
                </FormLabel>
                <FormControl>
                  <MultiSelectWithSearch
                    bindLabel="retailer_name"
                    bindValue="retailer_id"
                    options={retailerList}
                    value={field.value}
                    onChange={field.onChange}
                    noLimit={true}
                    placeholder="Select Retailers"
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="stop_key"
            render={({ field }) => (
              <FormItem className="">
                <FormLabel>Stop Key</FormLabel>
                <FormControl>
                  <ArrayInput
                    value={field.value}
                    onChange={field.onChange}
                    placeholder="Stop Key"
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>

        <hr className="mt-5" />
        <DialogFooter className="p-6 flex !justify-start">
          <Button
            type="submit"
            className="w-[120px]"
            disabled={form.formState.isSubmitting}
          >
            {form.formState.isSubmitting ? (
              <IconRender
                name="LoaderCircle"
                className="w-5 animate-spin text-white zoom-in-150"
              />
            ) : (
              "Save"
            )}
          </Button>
          <Button
            type="submit"
            onClick={() => onOpenChange(false)}
            variant={"outline"}
            className="w-[120px]"
          >
            Close
          </Button>
        </DialogFooter>
      </form>
    </Form>
  );
};
